module.exports = __webpack_public_path__ + "img/bg_slider_1.095347d7.png";